import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ListLayout } from 'gung-list';
import { OrderService, SelectedCustomerService, MetadataService, CustomerService, Order } from 'gung-standard';
import { JeevesOrderListConfigService } from 'gung-standard-jeeves';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { TyloJeevesOrderCardListComponent } from '../components/tylo-jeeves-order-card-list/tylo-jeeves-order-card-list.component';
import { DateUtilService } from 'gung-common';

@Injectable({
  providedIn: 'root'
})
export class TyloJeevesOrderListConfigService extends JeevesOrderListConfigService {

  getItems(): Observable<Order[]> {
    return super.getItems().pipe(map(orders => orders.filter(o => o.extra.oh.ordstat !== 90)));
  }

  getLayouts(): ListLayout<Order>[] {
    return [
      {
        ...super.getLayouts()[0],
        getListItemComponent: () => TyloJeevesOrderCardListComponent
      }
    ];
  }
}
